export const companies = [
  {
    slug: 'encode',
    name: 'enCODE',
    navLabel: 'enCODE',
    group: 'venture',
    logo: '/new_images/logos/encode.webp',
    category: 'Creative learning',
    headline: 'Where creative learning becomes real capability',
    summary: 'An AI-led creative learning platform that connects education, industry exposure, mentorship and career development.',
    seoTitle: 'enCODE | Creative Learning Platform',
    seoDescription: 'enCODE is InnovHer’s AI-led creative learning platform. Learners build skills, portfolios and career direction through mentorship, projects and industry exposure.',
    keywords: 'enCODE InnovHer, creative learning platform India, AI learning pathways, portfolio based education, interdisciplinary careers Jaipur',
    intro: [
      'enCODE is an AI-led creative learning platform that connects education, industry exposure, mentorship and career development within one integrated ecosystem.',
      'Built for learners navigating creative and interdisciplinary careers, enCODE goes beyond passive course consumption. It enables learners to explore their interests, build relevant skills, apply their knowledge and create visible evidence of their capabilities through projects, challenges and portfolio-based experiences.',
    ],
    statement: {
      title: 'Learn. Create. Connect. Collaborate.',
      text: 'Creative careers are no longer defined by one subject, one qualification or one fixed path. enCODE gives learners the flexibility to explore multiple disciplines while building the practical, creative and professional capabilities required by evolving industries.',
    },
    audienceTitle: 'Who enCODE is for',
    audience: [
      'Students exploring creative and interdisciplinary career paths',
      'Learners building practical, future-ready skills',
      'Emerging designers and creative professionals strengthening their portfolios',
      'Professionals looking to upskill or transition into new domains',
      'Mentors and practitioners sharing industry knowledge',
      'Institutions seeking stronger industry integration and applied learning',
      'Organisations looking to engage with emerging creative talent',
    ],
    blocks: [
      {
        title: 'The enCODE learning ecosystem',
        items: [
          { title: 'Personalised learning', text: 'AI-led pathways help learners identify relevant domains, skills and experiences based on their interests, progress and career direction.' },
          { title: 'Applied courses', text: 'Curated learning experiences combine concepts with assignments, projects and practical outputs that demonstrate genuine understanding.' },
          { title: 'Expert mentorship', text: 'Industry professionals and domain experts guide learners through feedback, portfolio reviews, skill development and career decisions.' },
          { title: 'Masterclasses and workshops', text: 'Live sessions provide exposure to emerging practices, professional workflows, tools and perspectives across creative industries.' },
          { title: 'Challenges and competitions', text: 'Real-world briefs encourage learners to solve problems, collaborate, experiment and present their ideas with confidence.' },
          { title: 'Industry exposure', text: 'Studio interactions, industry visits, live projects and professional engagements help learners understand how creative work happens beyond the classroom.' },
          { title: 'Portfolio development', text: 'Every meaningful learning experience contributes to a visible body of work that reflects the learner’s skills, thinking and creative growth.' },
        ],
      },
    ],
    prose: [
      {
        title: 'Learning beyond completion',
        paragraphs: [
          'Traditional learning often measures progress through attendance, tests and certificates. enCODE focuses on what learners can understand, create, explain and apply.',
          'Progress is built through participation, practical work, feedback and continuous improvement, helping learners develop capabilities that can be demonstrated to institutions, collaborators and employers.',
        ],
      },
      {
        title: 'From learning to opportunity',
        paragraphs: [
          'enCODE connects skill development with real career direction. Portfolio reviews, live projects, industry interaction, internships and opportunity mapping help learners understand where their capabilities can lead.',
          'The focus is not only on completing learning. It is on building confidence, capability and proof of work.',
        ],
      },
    ],
    lists: [
      {
        title: 'Interdisciplinary by design',
        intro: 'enCODE enables learners to explore connected pathways across design, technology, business, culture and society.',
        items: [
          'Design and creative arts',
          'Architecture and the built environment',
          'Technology and digital innovation',
          'Communication and media',
          'Business and entrepreneurship',
          'Education and human behaviour',
          'Culture, craft and heritage',
          'Sustainability and social impact',
          'Experience and service design',
          'Science, well-being and human-centred innovation',
        ],
      },
      {
        title: 'Skills for a changing world',
        items: [
          'Creative and critical thinking',
          'Problem-solving and decision-making',
          'Communication and presentation',
          'Collaboration and leadership',
          'Digital and design literacy',
          'Adaptability and self-management',
          'AI-augmented creativity',
          'Systems and interdisciplinary thinking',
        ],
      },
    ],
    roles: [
      { title: 'For learners', text: 'Personalised learning, mentorship, practical experiences and portfolio-building opportunities.' },
      { title: 'For mentors', text: 'A platform to share knowledge, guide emerging talent and contribute to industry-relevant learning.' },
      { title: 'For institutions', text: 'An integrated layer for applied education, industry exposure and capability-based outcomes.' },
      { title: 'For industry', text: 'Access to emerging talent through challenges, projects, portfolio engagement and collaborative learning experiences.' },
    ],
    close: {
      title: 'Create the future you want to enter',
      text: 'enCODE brings together learning, application, exposure and opportunity so learners can move forward with greater clarity and confidence.',
      line: 'Learn with purpose. Create with confidence. Build what comes next.',
    },
    cta: { label: 'Explore enCODE', to: '/contact' },
    galleryEyebrow: 'Inside enCODE',
    galleryTitle: 'Learning that looks like real creative work',
    gallery: [
      '/CODE/IMG_3312.webp',
      '/CODE/DSC_0015.webp',
      '/CODE/IMG_0250.webp',
      '/CODE/_I7A0226.webp',
      '/CODE/DSC_0022.webp',
      '/CODE/IMG_0979.webp',
      '/CODE/IMG_3302.webp',
      '/CODE/_I7A9408 (1).webp',
      '/CODE/DSC01601.webp',
      '/CODE/DSC03692.webp',
    ],
  },
  {
    slug: 'beyond-ability-x',
    name: 'Beyond Ability X',
    navLabel: 'Beyond Ability X',
    group: 'venture',
    logo: '/new_images/logos/Beyond Ability X Logo_Purple.webp',
    category: 'Inclusive sport',
    headline: 'Redefining the future of inclusive sport',
    summary: 'India’s professional sports ecosystem for athletes with disabilities, leagues, development, technology and visibility.',
    seoTitle: 'Beyond Ability X | Inclusive Sport Ecosystem',
    seoDescription: 'Beyond Ability X (BAX) is building India’s professional sports ecosystem for athletes with disabilities, combining leagues, athlete development, technology and media.',
    keywords: 'Beyond Ability X, BAX, inclusive sport India, athletes with disabilities, para sport league, InnovHer',
    intro: [
      'Beyond Ability X (BAX) is building India’s first professional sports ecosystem dedicated to athletes with disabilities.',
      'By bringing together competitive leagues, athlete development, technology, media and community participation, BAX is creating a structured pathway through which sporting talent can be discovered, developed, showcased and transformed into sustainable opportunity.',
    ],
    statement: {
      title: 'Beyond disability. Built around ability.',
      text: 'Talent is universal. Access to opportunity is not. Across India, thousands of athletes with disabilities possess the skill, determination and ambition to compete professionally but lack organised competitions, quality training, visibility and long-term career pathways.',
    },
    audienceTitle: 'Who BAX supports',
    audience: [
      'Athletes with disabilities seeking professional sporting opportunities',
      'Emerging players requiring structured training and development',
      'Coaches, academies and sporting professionals advancing inclusive sport',
      'Families and communities supporting athletes’ journeys',
      'Brands and organisations committed to inclusion and social impact',
      'Sports bodies and institutions working to expand accessible competition',
    ],
    blocks: [
      {
        title: 'The BAX ecosystem',
        items: [
          { title: 'Professional leagues', text: 'Structured sporting competitions that provide athletes with visibility, competitive exposure and opportunities for career progression.' },
          { title: 'Athlete development', text: 'Training, coaching and sports-science support designed to help athletes strengthen their performance and prepare for professional competition.' },
          { title: 'Technology platform', text: 'A connected digital ecosystem that enables athlete registration, verified profiles, performance records, talent discovery and recruitment.' },
          { title: 'Media and storytelling', text: 'Original content, documentaries and athlete stories that bring sporting journeys to wider audiences and build stronger public recognition.' },
          { title: 'Community building', text: 'A growing network of athletes, coaches, families, fans, institutions and partners working together to advance inclusive sport.' },
          { title: 'Strategic partnerships', text: 'Collaboration with sporting bodies, government institutions, corporates, academies and ecosystem partners to expand opportunity and create long-term impact.' },
        ],
      },
    ],
    prose: [
      {
        title: 'Discovering talent across India',
        paragraphs: [
          'BAX aims to identify sporting potential across cities, towns and communities through accessible athlete registration, talent discovery and selection pathways.',
          'By reducing geographical and structural barriers, the platform enables deserving athletes to enter a more organised system of training, evaluation and competitive participation.',
        ],
      },
      {
        title: 'From participation to professional opportunity',
        paragraphs: [
          'Beyond Ability X goes beyond organising sporting events. It is building a long-term pathway through which athletes can move from discovery and development to professional competition, recognition and career growth.',
          'Sport creates the platform. Technology connects the ecosystem. Media builds recognition. Opportunity enables athletes to move forward.',
        ],
      },
    ],
    lists: [
      {
        title: 'What BAX is building',
        items: [
          'Structured pathways for identifying and developing sporting talent',
          'Professional competitions designed around performance and excellence',
          'Greater visibility for athletes with disabilities',
          'Digital athlete identities and verified performance histories',
          'Stronger connections between athletes, coaches, institutions and opportunities',
          'Commercial and professional pathways within inclusive sport',
          'A nationwide movement that celebrates ability, ambition and achievement',
        ],
      },
    ],
    close: {
      title: 'Building a future without barriers',
      text: 'Beyond Ability X envisions a sporting landscape where disability does not determine the scale of an athlete’s opportunity.',
      line: 'Sport. Media. Technology. Opportunity.',
    },
    cta: { label: 'Explore Beyond Ability X', to: '/contact' },
    galleryEyebrow: 'Beyond Ability X',
    galleryTitle: 'Ability, competition and community, in frame',
    gallery: [
      '/BAX/A29I2982.webp',
      '/BAX/A29I3197.webp',
      '/BAX/A29I3396.webp',
      '/BAX/A29I3557.webp',
      '/BAX/A29I4026.webp',
      '/BAX/A29I4044.webp',
      '/BAX/A29I3564.webp',
    ],
  },
  {
    slug: 'bharat-ventures',
    name: 'Bharat Ventures',
    navLabel: 'Bharat Ventures',
    group: 'venture',
    logo: '/new_images/logos/Bharat Ventures Black.webp',
    category: 'Venture acceleration',
    headline: 'Building scalable ventures for the next Bharat',
    summary: 'InnovHer’s venture acceleration platform for startups building for India’s diverse and fast-changing markets.',
    seoTitle: 'Bharat Ventures | Venture Acceleration for India',
    seoDescription: 'Bharat Ventures helps founders turn promising Indian startups into structured, market-ready and investment-ready ventures through strategy, mentorship and ecosystem access.',
    keywords: 'Bharat Ventures, startup acceleration India, venture building Jaipur, D2C India, investment readiness, InnovHer',
    intro: [
      'Bharat Ventures is InnovHer’s venture acceleration platform created to discover, strengthen and scale ambitious startups building for India’s diverse and rapidly evolving markets.',
      'It works alongside founders to transform promising businesses into structured, market-ready and investment-ready ventures through strategic guidance, operational support, expert mentorship and access to the wider startup ecosystem.',
    ],
    statement: {
      title: 'Built for India’s emerging opportunities',
      text: 'Some of India’s most significant opportunities are being created beyond conventional markets and established business models. Bharat Ventures supports founders who understand local realities, solve meaningful problems and have the potential to build scalable businesses.',
    },
    audienceTitle: 'Who Bharat Ventures supports',
    audience: [
      'Early-stage startups with validated ideas or initial market traction',
      'Founders building solutions for emerging Indian markets',
      'Consumer and D2C brands with the potential to scale',
      'Technology-led ventures solving real business or social challenges',
      'Impact-driven enterprises creating measurable economic or social value',
      'Entrepreneurs seeking structured growth and investment readiness',
    ],
    blocks: [
      {
        title: 'The Bharat Ventures approach',
        items: [
          { title: 'Venture strategy', text: 'Clarify the business model, market opportunity, competitive positioning and long-term growth direction.' },
          { title: 'Market readiness', text: 'Strengthen product-market alignment, customer understanding, pricing, distribution and go-to-market strategy.' },
          { title: 'Business building', text: 'Support founders in developing stronger operations, teams, governance systems and execution capabilities.' },
          { title: 'Brand and growth', text: 'Build a clear market identity and create growth strategies that improve visibility, customer acquisition and engagement.' },
          { title: 'Investment readiness', text: 'Prepare ventures with stronger financial models, valuations, pitch materials, documentation and fundraising strategies.' },
          { title: 'Ecosystem access', text: 'Connect founders with mentors, industry professionals, strategic partners, investors and market opportunities.' },
        ],
      },
    ],
    prose: [
      {
        title: 'From potential to performance',
        paragraphs: [
          'Bharat Ventures goes beyond advisory support. It works closely with founders to identify critical business gaps, define priorities and translate strategy into measurable action.',
          'Through structured reviews, expert guidance and milestone-based execution, startups develop the clarity and capabilities required to navigate growth, build investor confidence and scale responsibly.',
        ],
      },
      {
        title: 'Rooted in Bharat. Built for scale.',
        paragraphs: [
          'Bharat Ventures believes that transformative businesses can emerge from every region, sector and community. By combining local understanding with structured venture-building support, the initiative helps founders build companies that are relevant to Bharat and competitive in larger markets.',
        ],
      },
    ],
    lists: [
      {
        title: 'Focus areas',
        items: [
          'Consumer and D2C',
          'Technology and digital solutions',
          'Impact and inclusive innovation',
          'Education and skilling',
          'Healthcare and well-being',
          'Sustainability and climate-focused solutions',
          'Agribusiness and rural innovation',
          'Emerging-market services',
        ],
      },
      {
        title: 'What founders build',
        items: [
          'A sharper and more scalable business model',
          'Stronger market positioning and customer strategy',
          'Improved financial and operational discipline',
          'A clear go-to-market and growth roadmap',
          'Investor-ready business materials and documentation',
          'Greater access to mentors, partners and capital networks',
          'The confidence and capabilities required for sustainable scale',
        ],
      },
    ],
    close: {
      title: 'Build what Bharat needs next',
      text: 'For founders solving meaningful problems and building businesses with the ambition to scale, Bharat Ventures provides the strategic foundation, ecosystem access and execution support needed to move forward.',
      line: 'Build with purpose. Scale with strength. Create for Bharat.',
    },
    cta: { label: 'Connect with Bharat Ventures', to: '/contact' },
    galleryEyebrow: 'Bharat Ventures',
    galleryTitle: 'Founders, mentors and moments from the build',
    gallery: [
      '/Bharat Ventures/RS103154.webp',
      '/Bharat Ventures/RS103748.webp',
      '/Bharat Ventures/RS104041.webp',
      '/Bharat Ventures/RS104216.webp',
      '/Bharat Ventures/RS103975.webp',
      '/Bharat Ventures/RS104325.webp',
      '/Bharat Ventures/RS103990.webp',
      '/Bharat Ventures/RS104052.webp',
    ],
  },
  {
    slug: 'ctpl',
    name: 'CTPL',
    navLabel: 'CTPL',
    group: 'venture',
    logo: '/new_images/logos/ctpl.online.webp',
    category: 'Education technology',
    headline: 'Transforming education from admission to employability',
    summary: 'Education technology and institutional growth for universities, admissions, engagement, enrolment and career-ready learning.',
    seoTitle: 'CTPL | Education Technology for Institutions',
    seoDescription: 'CTPL helps universities and institutions modernise admissions, student engagement and industry-aligned learning through Admissions Xlerator, SREM and NextGen Academy.',
    keywords: 'CTPL, CTPL.online, university admissions software India, student recruitment CRM, higher education technology, InnovHer',
    intro: [
      'CTPL is an education technology and institutional growth company helping universities and educational institutions modernise how they attract, engage, enrol and prepare students for the future.',
      'By bringing together education-focused technology, admissions management, digital marketing, student counselling and industry-aligned learning, CTPL creates connected solutions that strengthen institutional growth and improve the student journey.',
    ],
    statement: {
      title: 'Building smarter education systems',
      text: 'When admissions, engagement and learning work in isolation, institutions lose visibility, efficiency and student opportunities. CTPL connects people, processes and technology into one coordinated education ecosystem.',
    },
    audienceTitle: 'Who CTPL works with',
    audience: [
      'Universities and higher-education institutions',
      'Colleges and professional education providers',
      'Schools and academic groups',
      'Institutional admissions and outreach teams',
      'Education leaders undertaking digital transformation',
      'Organisations developing industry-aligned learning programmes',
    ],
    blocks: [
      {
        title: 'The CTPL ecosystem',
        items: [
          { title: 'Admissions Xlerator', text: 'An integrated admissions growth solution that brings together student acquisition, digital marketing, counselling, lead management, brand engagement and enrolment support.' },
          { title: 'SREM', text: 'A student recruitment and enrolment management system that combines admissions workflows, CRM, automation, analytics and AI-enabled tools in one platform.' },
          { title: 'NextGen Academy', text: 'An industry-linked learning initiative that brings together academic knowledge, professional expertise and practical exposure to prepare learners for emerging careers.' },
        ],
      },
      {
        title: 'End-to-end admissions transformation',
        items: [
          { title: 'Student acquisition', text: 'Targeted campaigns and outreach help institutions reach relevant prospective students across digital and partner networks.' },
          { title: 'Lead management', text: 'Education-focused CRM systems centralise enquiries, track engagement and help admissions teams manage prospective students.' },
          { title: 'Student engagement', text: 'Automated communication, counselling support and query management help prospective students receive timely and relevant information.' },
          { title: 'Application and enrolment', text: 'Digital application systems simplify forms, payments, documentation, status tracking and communication throughout admissions.' },
          { title: 'Institutional intelligence', text: 'Real-time dashboards and analytics show campaign performance, counsellor productivity and enrolment progress.' },
          { title: 'Brand and reputation', text: 'Integrated communication, content, public relations and digital engagement strengthen how institutions are perceived.' },
        ],
      },
    ],
    prose: [
      {
        title: 'From data to better decisions',
        paragraphs: [
          'CTPL enables institutions to move beyond disconnected spreadsheets, platforms and vendors. By centralising admissions information and activity, leadership teams gain a clearer view of the student pipeline, campaign effectiveness and team performance.',
          'This helps institutions respond faster, allocate resources more effectively and make informed decisions throughout the admissions cycle.',
        ],
      },
      {
        title: 'Learning aligned with industry',
        paragraphs: [
          'Through NextGen Academy, CTPL extends its impact beyond admissions. Industry practitioners, academic experts and corporate partners contribute to learning experiences built around emerging technology, business and media.',
          'Projects, case studies, certifications, industry engagement and practical exposure help learners understand professional environments and build skills relevant to the changing world of work.',
        ],
      },
    ],
    lists: [
      {
        title: 'Technology built for education',
        intro: 'CTPL’s solutions are designed around the operational realities of educational institutions.',
        items: [
          'Student enquiries and applications',
          'Lead nurturing and counselling',
          'Marketing campaigns and automation',
          'Admissions teams and partner networks',
          'Digital payments and enrolment workflows',
          'Applicant communication and query resolution',
          'Assessments and online examinations',
          'Performance analytics and institutional reporting',
        ],
      },
      {
        title: 'What institutions gain',
        items: [
          'A connected and streamlined admissions ecosystem',
          'Stronger student acquisition and engagement',
          'Better visibility across the applicant journey',
          'More productive admissions and counselling teams',
          'Consistent communication across student touchpoints',
          'Data-led planning and performance management',
          'Improved digital experiences for applicants',
          'Stronger alignment between education and industry',
        ],
      },
    ],
    close: {
      title: 'Powering the future of education',
      text: 'CTPL works as an institutional growth partner, combining education-sector understanding with technology, marketing, process design and execution.',
      line: 'Connect institutions. Simplify admissions. Enable futures.',
    },
    cta: { label: 'Explore CTPL', to: '/contact' },
  },
  {
    slug: 'i2i',
    name: 'i2i',
    navLabel: 'i2i',
    group: 'venture',
    logo: '/new_images/logos/I2I.webp',
    category: 'Idea to impact',
    headline: 'From idea to commercial impact',
    summary: 'A venture engine that turns high-conviction ideas and early innovations into market-tested enterprises.',
    seoTitle: 'i2i | Idea to Impact Venture Engine',
    seoDescription: 'i2i is InnovHer’s commercialisation engine, converting high-conviction ideas, lab breakthroughs and early innovations into market-tested, commercially viable enterprises.',
    keywords: 'i2i InnovHer, idea to impact, startup commercialisation India, venture incubation Jaipur, go to market testing',
    intro: [
      'i2i is a dedicated venture engine converting high-conviction ideas, lab breakthroughs and early innovations into market-tested, commercially viable enterprises.',
      'It sits inside InnovHer’s venture-building system, taking concepts from first proof toward a business that can be built, tested and taken to market.',
    ],
    statement: {
      title: 'Commercialisation with discipline',
      text: 'An idea becomes a venture when it survives contact with a customer, a cost structure and a clear path to market. i2i is built for that passage.',
    },
    audienceTitle: 'Who i2i is for',
    audience: [
      'Founders with a high-conviction idea that still needs commercial proof',
      'Researchers and builders moving a breakthrough out of the lab',
      'Early teams that need a structured path from prototype to market',
    ],
    blocks: [
      {
        title: 'How i2i builds',
        items: [
          { title: 'Rapid prototyping and validation', text: 'Test the idea against real users and constraints before the venture hardens around the wrong assumption.' },
          { title: 'Commercial viability', text: 'Frame unit economics, offer design and the conditions under which the venture can stand on its own.' },
          { title: 'Go-to-market testing', text: 'Put the offer in front of a market and learn what actually converts.' },
          { title: 'Impact-led architecture', text: 'Shape ventures so commercial progress and measurable impact are designed together, not added later.' },
        ],
      },
    ],
    close: {
      title: 'Turn the idea into an enterprise',
      text: 'i2i is for teams ready to move from conviction to a market-tested venture, with InnovHer alongside the build.',
      line: 'From idea to impact.',
    },
    cta: { label: 'Explore i2i', to: '/contact' },
  },
  {
    slug: 'innovidea',
    name: 'InnovIdea',
    navLabel: 'InnovIdea',
    group: 'company',
    category: 'Brand, communication & growth',
    headline: 'Ideas deserve an identity powerful enough to travel',
    summary:
      'InnovIdea builds brand, communication and growth practice, transforming business ideas into brands that can be understood, experienced and remembered.',
    seoTitle: 'InnovIdea | Ideas Deserve an Identity Powerful Enough to Travel',
    seoDescription:
      'From positioning and identity to storytelling, digital presence, campaigns and market communication, InnovIdea works at the intersection of business strategy and creative expression.',
    keywords:
      'InnovIdea, brand strategy, positioning, storytelling, digital presence, innovidea.in, InnovHer',
    intro: [
      'InnovIdea builds brand, communication and growth practice, transforming business ideas into brands that can be understood, experienced and remembered.',
      'From positioning and identity to storytelling, digital presence, campaigns and market communication, InnovIdea works at the intersection of business strategy and creative expression.',
      'Its role extends beyond making ventures look better. It helps clarify what a business stands for, who it matters to and how that proposition can translate consistently across markets and touchpoints.',
      'Because building a venture is also about building perception, trust and relevance, turning an idea into an identity people can believe in.',
    ],
    statement: {
      title: 'Beyond looking better',
      text: 'Clarify what a business stands for, who it matters to, and how that proposition travels consistently across markets and touchpoints.',
    },
    blocks: [
      {
        title: 'What InnovIdea covers',
        items: [
          { title: 'Positioning & identity', text: 'Define what the business stands for and how it is recognised.' },
          { title: 'Storytelling', text: 'Narratives that make the venture understood, experienced and remembered.' },
          { title: 'Digital presence', text: 'Presence that carries the brand across channels and markets.' },
          { title: 'Campaigns & market communication', text: 'Expression that builds perception, trust and relevance.' },
        ],
      },
    ],
    close: {
      title: 'Visit InnovIdea',
      text: 'Explore the full brand, communication and growth practice on innovidea.in, or start a conversation with InnovHer.',
      line: 'Ideas deserve an identity powerful enough to travel.',
    },
    cta: { label: 'Visit InnovIdea', to: 'https://innovidea.in', external: true },
  },
  {
    slug: 'innovz',
    name: 'InnovZ',
    navLabel: 'InnovZ',
    group: 'company',
    category: 'Leadership & talent',
    headline: 'From inheriting enterprise to imagining what comes next.',
    summary: 'A six-month immersive experience introducing the next generation of business families to startups, innovation and venture investing.',
    seoTitle: 'InnovZ | From Inheriting Enterprise to Imagining What Comes Next',
    seoDescription: 'InnovZ is a six-month immersive experience introducing the next generation of business families to startups, innovation and venture investing inside the InnovHer ecosystem.',
    keywords: 'InnovZ, Gen Z entrepreneurship, family business next generation, venture exposure, investor mindset, InnovHer',
    intro: [
      'InnovZ introduces the next generation of business families to the world of startups, innovation and venture investing.',
      'Designed as a six-month immersive experience for Gen Z and emerging second- and third-generation entrepreneurs, InnovZ places participants inside the InnovHer ecosystem, alongside founders, investors, mentors, technologies and real ventures.',
    ],
    statement: {
      title: 'Not a classroom program. A runway into the venture economy.',
      text: 'Through continuous exposure, venture interactions, learning sessions and hands-on experiences, participants begin developing the perspective to eventually enter a family enterprise with an innovation lens, build something of their own, or participate in the ecosystem as an informed investor.',
    },
    audienceTitle: 'Who InnovZ is for',
    audience: [
      'Gen Z entrepreneurs',
      'Second-generation business leaders',
      'Third-generation entrepreneurs',
      'Next-generation family business members',
      'Emerging founders',
      'Future investors',
    ],
    blocks: [
      {
        title: 'Where it can lead',
        items: [
          { title: 'Enter the family enterprise', text: 'Return with an innovation lens, ready to imagine what the next chapter of the business can become.' },
          { title: 'Build something of your own', text: 'Use continuous exposure to founders, mentors and real ventures to shape and start your own path.' },
          { title: 'Participate as an informed investor', text: 'Develop the perspective to engage with the venture economy with clarity, curiosity and judgment.' },
        ],
      },
    ],
    lists: [
      {
        title: 'What defines InnovZ',
        items: [
          '6-month immersion',
          'Gen Z',
          'Family business',
          'Venture exposure',
          'Investor mindset',
          'Innovation',
        ],
      },
    ],
    close: {
      title: 'Step into the venture economy',
      text: 'For Gen Z and emerging second- and third-generation entrepreneurs ready to move from inheriting enterprise to imagining what comes next.',
      line: 'Not a classroom program. A runway into the venture economy.',
    },
    cta: { label: 'Explore InnovZ', to: '/contact' },
  },
];

export const ventureCompanies = companies.filter((c) => c.group === 'venture');

export function getCompany(slug) {
  return companies.find((c) => c.slug === slug);
}
